import React, { useEffect, useState } from 'react'
import feather from 'feather-icons';
import { useNavigate } from 'react-router-dom';
import ApiRequest, { loadNow, loader } from '../Common/restservice';
import { errorToast, successToast } from '../Common/showtoast';
function Dashboard() {
  const navigate = useNavigate();
  const [stateObj, setStateObj] = useState({});
  useEffect(() => {
    feather.replace();
    GetDashboardDetails();
  }, [])
  const GetDashboardDetails = async () => {
    let res = await ApiRequest('GetDashboardDetails.asp', 'GET', null, { Authorization: localStorage.getItem('token') });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        navigate('/');
      }
      return;
    }
    console.log(res);
    setStateObj(res);
  }
  return (
    <section className="content">
      {/* <label>Facing delay in load balance? <span className='badge badge-primary mb-3' style={{ cursor: 'pointer' }} onClick={() => {
        loader.style.opacity = 1;
        loader.style.display = "block";;
        fetch("https://happiedealz.com/get_bnb_token_trans_single.asp?memberid=" + localStorage.getItem('username')).then((res) => res.json()).then((res) => {
          successToast("Completed check your deposit history now");
          loadNow(1);
          GetDashboardDetails();
        })
      }}>Click Here</span></label> */}
      <div className="row">
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12">
          <div className="box box-body be-1 fill-icon">
            <div className="d-flex align-items-center">
              <div className="w-70 h-70 me-15 bg-primary-light rounded-circle text-center p-10">
                <div className="w-50 h-50 bg-dark rounded-circle align-items-center justify-content-center d-flex">
                  <img src={require('../Assets/Images/logoicon.png')} />
                </div>
              </div>
              <div className="d-flex flex-column">
                <h3 className="text-dark hover-primary m-0 fw-600">{stateObj.RankName || "-"}</h3>
                <span className="text-fade fs-12">{stateObj.accountstatus === "Active" ? "Active" : "Inactive"}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12">
          <div className="box box-body be-1 fill-icon">
            <div className="d-flex align-items-center">
              <div className="w-70 h-70 me-15 bg-success-light rounded-circle text-center p-10">
                <div className="w-50 h-50 bg-success rounded-circle">
                  <i className="fa fa-fw fa-users fs-20 l-h-50"></i>
                </div>
              </div>
              <div className="d-flex flex-column">
                <span className="text-fade fs-12">Total Team</span>
                <h3 className="text-dark hover-primary m-0 fw-600">{stateObj.totalteam}</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12">
          <div className="box box-body be-1 fill-icon">
            <div className="d-flex align-items-center">
              <div className="w-70 h-70 me-15 bg-primary-light rounded-circle text-center p-10">
                <div className="w-50 h-50  bg-primary rounded-circle">
                  <i class="fa fa-handshake-o fs-20 l-h-50"></i>
                </div>
              </div>
              <div className="d-flex flex-column">
                <span className="text-fade  fs-12">Direct Team</span>
                <h3 className="text-dark hover-primary m-0 fw-600">{stateObj.directcount}</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-12">
          <div className="box box-body be-1 fill-icon">
            <div className="d-flex align-items-center">
              <div className="w-70 h-70 me-15 bg-info-light rounded-circle text-center p-10">
                <div className="w-50 h-50 bg-info rounded-circle">
                  <i className="fa fa-suitcase fs-20 l-h-50"></i>
                </div>
              </div>
              <div className="d-flex flex-column">
                <span className="text-fade fs-12">Total Team Business</span>
                <h3 className="text-dark hover-primary m-0 fw-600">{stateObj.teambusiness}</h3>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="box box-body">
        <div className="row">
        <div className="col-lg-4 mt-2">
            <div className="box-body rounded-0 p-0 pb-lg-0 pb-sm-15 pb-xs-15 be-1 fill-icon">
              <div className="d-flex align-items-center">
                <div className="w-60 h-60 me-15 bg-primary-light rounded-circle text-center p-10">
                  <div className="w-40 h-40 bg-primary rounded-circle">
                    <i className="fa fa-inr fs-20 l-h-40"></i>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <span className="text-fade fs-12">Direct Incentive</span>
                  <h5 className="text-dark hover-primary m-0 fw-600">Rs. {stateObj.incentive || 0}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mt-2">
            <div className="box-body rounded-0 p-0 pb-lg-0 pb-sm-15 pb-xs-15 be-1 fill-icon">
              <div className="d-flex align-items-center">
                <div className="w-60 h-60 me-15 bg-primary-light rounded-circle text-center p-10">
                  <div className="w-40 h-40 bg-primary rounded-circle">
                    <i className="fa fa-inr fs-20 l-h-40"></i>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <span className="text-fade fs-12">Team Incentive</span>
                  <h5 className="text-dark hover-primary m-0 fw-600">Rs. {stateObj.teamincentive || 0}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mt-2">
            <div className="box-body rounded-0 p-0 pb-lg-0 pb-sm-15 pb-xs-15 be-1 fill-icon">
              <div className="d-flex align-items-center">
                <div className="w-60 h-60 me-15 bg-success-light rounded-circle text-center p-10">
                  <div className="w-40 h-40 bg-success rounded-circle">
                    <i className="fa fa-users fs-20 l-h-40"></i>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <span className="text-fade fs-12">Team Bonus</span>
                  <h5 className="text-dark hover-primary m-0 fw-600">Rs. {stateObj.teambonus || 0}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mt-2">
            <div className="box-body rounded-0 p-0 pb-lg-0 pb-sm-15 pb-xs-15 be-1 fill-icon">
              <div className="d-flex align-items-center">
                <div className="w-60 h-60 me-15 bg-info-light rounded-circle text-center p-10">
                  <div className="w-40 h-40 bg-info rounded-circle">
                    <i className="fa fa-fw fa-user fs-20 l-h-40"></i>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <span className="text-fade fs-12">Global Bonus</span>
                  <h5 className="text-dark hover-primary m-0 fw-600">Rs. {stateObj.globalbonus || 0}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mt-2">
            <div className="box-body rounded-0 p-0 pb-lg-0 pb-xs-15 be-1 fill-icon">
              <div className="d-flex align-items-center">
                <div className="w-60 h-60 me-15 bg-danger-light rounded-circle text-center p-10">
                  <div className="w-40 h-40 bg-danger rounded-circle">
                    <i className="fa fa-user-circle-o fs-20 l-h-40"></i>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <span className="text-fade fs-12">Royalty Bonus</span>
                  <h5 className="text-dark hover-primary m-0 fw-600">Rs. {stateObj.royalty || 0}</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mt-2">
            <div className="box-body rounded-0 p-0 fill-icon">
              <div className="d-flex align-items-center">
                <div className="w-60 h-60 me-15 bg-warning-light rounded-circle text-center p-10">
                  <div className="w-40 h-40 bg-warning rounded-circle">
                    <i className="fa fa-pie-chart fs-24 l-h-40"></i>
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <span className="text-fade fs-12">Total</span>
                  <h5 className="text-dark hover-primary m-0 fw-600">Rs. {stateObj.totalincome || 0}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xxxl-8 col-xxl-8 col-xl-8 col-lg-5 h-100">
          <div className="box">
            <div className="box-body fill-img" style={{ minHeight: '190px' }}>
              <h6 className='text-primary'>NEWS</h6>
              <marquee>{stateObj.news || "Welcome to Happie Marketing"}</marquee>
            </div>
          </div>
        </div>
        <div className="col-xxxl-4 col-xxl-4 col-xl-4 col-lg-5">
          <div className="box">
            <div className="box-body fill-img">
              <div className="d-flex align-items-center">
                <div className="w-80 h-80 me-15 bg-success-light rounded-3 d-flex p-5 justify-content-center align-items-center">
                  <div className="w-50 h-50 bg-light rounded-3" onClick={() => {
                    navigate('/income/work');
                  }}>
                    <img src={require("../Assets/Images/wallet.png")} />
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <h4 className="text-fade mb-1">Income wallet</h4>
                  <h3 className="text-success hover-primary m-0 fw-600">Rs. {stateObj.payoutWalletBalance}</h3>
                </div>
              </div>
              <div class="row mb-0 mt-3">
                <div onClick={() => {
                  navigate('/withdraw');
                }} class="col-md-6 col-6 p-0 border-end text-end text-center" style={{ cursor: 'pointer', fontSize: '12px' }}>
                  <p class="mb-0 p-3">
                    <i class="text-danger" data-feather="download"> </i> Withdraw
                  </p>
                </div>
                <div onClick={() => {
                  navigate('/transactions/cash');
                }} class="col-md-6 col-6 p-0 text-center" style={{ cursor: 'pointer', fontSize: '12px' }}>
                  <p class="mb-0 p-3"><i class="text-primary" data-feather="package"> </i> Transactions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="box box-body">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
            <div className="box-body rounded-0 p-0 pb-lg-0 pb-sm-15 pb-xs-15 be-1 fill-icon">
              <h3>Invite Link</h3>
              <div className='row justify-content-center align-items-center'>
                <div className='col-xxl-10 col-xl-10 col-lg-8 col-md-6 col-12'>
                  <input className='form-control' readOnly placeholder='Affiliate link' value={`https://happiemarketing.com/office/#/register/${stateObj.username}`} />
                </div>
                <div className='col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-12'>
                  <button onClick={() => {
                    navigator.clipboard.writeText(`https://happiemarketing.com/office/#/register/${stateObj.username}`);
                    successToast("Copied");
                  }} className='btn btn-primary col-lg-12'>COPY</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Dashboard